<div class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom custom-primary"
		>
			<div class="o-stack__cell">
				<h5 class="email-summary-header">{{ sectiontitle }}</h5>
			</div>
		</div>
		<div class="analytics-portlet-content {{ sectionclass }}" *ngIf="hasData">
			<ngx-datatable
				class="ngx-datatable bootstrap material datatable linksummary_table"
				[rows]="linkSummaryDetails"
				[sortType]="'single'"
				[cssClasses]="cssClasses"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="datatableconfig.footerHeight ? datatableconfig.footerHeight : 50"
				[rowHeight]="'auto'"
				[limit]="10"
			>
				<ngx-datatable-column name="url" [cellClass]="'url'" [headerClass]="'linkSummaryUrlHeader'">
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span> url </span>
					</ng-template>
					<ng-template let-row="row" let-column="column" ngx-datatable-cell-template>
						<div class="linksummary-logo" [ngStyle]="{ 'background-image': 'url(' + row['logo_path'] + ')' }"></div>
						<div appTooltip [options]="tooltipOptions" class="linksummary-name" title="row['url']" [title]="row['url']">
							{{ row['url'] }}
						</div>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="clicks" [cellClass]="'clicks'" [headerClass]="'linkSummaryClicksHeader'">
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span (click)="sort()" class="cursorPointer"> clicks </span>
					</ng-template>
					<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
						<div class="linksummary-data" [title]="row['clicks']">{{ row['formatted_clicks'] }}</div>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="clicks_rate" [cellClass]="'clickrate'" [headerClass]="'linkSummaryClickRateHeader'">
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span> click rate </span>
					</ng-template>
					<ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
						<div class="linksummary-data" [title]="row['clicks_rate']">{{ row['clicks_rate'] }}%</div>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="no-data-email-link-summary">
				<div class="no-data-text">No Data Available</div>
			</div>
		</div>
	</div>
</div>
